import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { WebServicesService } from '../web-services/web-services.service';
import { UserAccess } from './user-access.model';
import { NotificationService } from '../../service/notification/notification.service';

@Injectable({
	providedIn: 'root'
})
export class UserAccessService {

	constructor(
		private notificationService: NotificationService,
		private translateService: TranslateService,
		private webServicesService: WebServicesService
	) { }

	/* Appels aux webServices */

	public getUserAccess(userId: string): Promise<UserAccess[]> {
		console.log('RÃ©cupÃ©ration des droits de l\'utilisateur ' + userId);
		return this.webServicesService.getList<UserAccess>('/user_access?userId=' + userId)
			.then(pagedData => {
				if (pagedData && pagedData._embedded)
					return Promise.resolve(pagedData._embedded[Object.keys(pagedData._embedded)[0]]);
				else
					return Promise.resolve([]);
			})
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('GET_USER_ACCESS_ERROR'));
				return Promise.reject(error);
			})
	}

	public putUserAccess(applicationId: string, roleId: string, userId: string, customerTreeId: number, granted: boolean): Promise<UserAccess> {
		console.log('Ajout d\'un nouveau droit utilisateur');
		let json = {
			applicationId: applicationId,
			roleId: roleId,
			userId: userId,
			customerTreeId: customerTreeId,
			granted: granted
		}
		return this.webServicesService.put<UserAccess>('/user_access', json)
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('ERROR'));
				return Promise.reject(error);
			})
	}

	public deleteUserAccess(userAccessId: number): Promise<any> {
		console.log("Suppression du droit utilisateur " + userAccessId);
		return this.webServicesService.delete('/user_access/' + userAccessId)
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('ERROR'));
				return Promise.reject(error);
			})
	}
}
